/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { setFullCart } from './cartHydrationActions';

interface CartLoadingState {
    isLoading: boolean;
    isInitialized: boolean;
    isProductDataAvailable: boolean;
}

export const getInitialState = (): CartLoadingState => ({
    isLoading: false,
    isInitialized: false,
    isProductDataAvailable: false,
});

const slice = createSlice({
    name: 'cartLoading',
    initialState: getInitialState(),
    reducers: {
        initLoading: (state) => {
            state.isLoading = true;
        },
        finishLoading: (state) => {
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.cartLoading);
    },
});

export const { initLoading, finishLoading } = slice.actions;

export default slice.reducer;
